import { useCallback, useContext } from "react";
import { LocaleRecord } from "../../../shared/types";
import { StoreContext } from "../../context/store.context";

type Localize = (phrase: keyof LocaleRecord, ...args: string[]) => string;
type LocalizeString = (phrase: string, ...args: string[]) => string;

export function useLocalization(): {
  record: LocaleRecord;
  localize: Localize;
  localizeString: LocalizeString;
} {
  const store = useContext(StoreContext);
  const locale = store.locale;

  const localize = useCallback<Localize>(
    (phrase, ...args) => {
      const localized = locale[phrase];

      if (!localized) {
        return phrase;
      }

      if (args.length === 0) {
        return localized;
      }

      return localized.replace(/{(\d+)}/g, (_, number) => {
        return typeof args[number] !== "undefined" ? args[number] : "";
      });
    },
    [locale],
  );

  const localizeString = useCallback<LocalizeString>(
    (phrase, ...args) => {
      if (phrase in locale) {
        return localize(phrase as keyof LocaleRecord, ...args);
      }

      return phrase;
    },
    [localize],
  );

  return {
    record: locale,
    localize,
    localizeString,
  };
}
